import { all } from 'redux-saga/effects';
import flags from './flag';

export const flagsSaga = function* root() {
  yield all([flags()]);
};
